import {
  IAllocationClient,
  IAllocationClientsByGroup,
} from '~/services/api/clientAllocation/types';

const groupAllocationClients = (
  groups: IAllocationClientsByGroup[],
  clients: IAllocationClient[],
): IAllocationClientsByGroup[] => {
  const clientsMap = new Map(clients.map(client => [client.id, client]));
  return groups.reduce((acc, group) => {
    const filteredClients = group.clients.reduce((clientAcc, client) => {
      if (clientsMap.has(client.id)) {
        clientAcc.push({
          ...client,
          memo: clientsMap.get(client.id)?.memo || client.memo,
        });
      }
      return clientAcc;
    }, [] as typeof group.clients);
    acc.push({
      ...group,
      clients: filteredClients,
    });
    return acc;
  }, [] as IAllocationClientsByGroup[]);
};

export default groupAllocationClients;
